<template>
	<div>
		<Input v-model="checkCode" placeholder="请输入验证码" class="check-code-input" :style="inputStyle"
			@on-change="inputChange" />
		<div class="check-code-button">
			<Button @click="countdown" :disabled='countdownState'>{{countdownValue}}</Button>
		</div>
		<!-- 自定义滑块验证码弹窗 -->
		<custom-captcha-dialog ref="captchaDialog" :device-id="deviceId" @verified="onCaptchaVerified"
			@close="onDialogClose" />
	</div>
</template>

<script>
	import CustomCaptchaDialog from '@/components/CustomCaptchaDialog.vue'
	import {
		getDeviceId
	} from '@/utils/device'
	export default {
		name: 'CheckCodeBox',
		props: {
			telephone: {
				type: String,
				default: ''
			},
			codeType: {
				type: String,
				default: ''
			},
			inputStyle: {
				type: Object,
				default: function(result) {
					return {}
				}
			}
		},
		components: {
			CustomCaptchaDialog
		},
		data() {
			return {
				registerToken:null, // 滑块验证成功后的注册会话令牌
				sessionToken: null, // 滑块验证成功后的登陆会话令牌
				userToken: null, // 绑定用户后的令牌
				deviceId: getDeviceId(), // 设备指纹（单页生命周期内不变）
				countdownValue: '获取验证码',
				countdownState: false,
				timeRemaining: 60,
				checkCode: '',
				randomCode: ''
			}
		},
		methods: {
			//绑定注册令牌
			async bindRegisterToken() {
				let self = this
				try {
					const res = await this.$axios.post('/api/captcha/bindRegister', {
						sessionToken: this.sessionToken,
						deviceId: this.deviceId,
						phoneNumber: this.telephone || null // 可选，提前绑定
					})
					if (res.data.success) {
						self.registerToken = res.data.registerToken
					} else {
						self.$Notice.error({
							title: '失败提示',
							duration: 3,
							desc: '令牌绑定失败'
						});
					}
					return res.data.success;
				} catch (err) {
					this.$Notice.error({
						title: '失败提示',
						duration: 3,
						desc: '安全验证绑定失败，请重试'
					});
					this.resetCaptcha();
					return false;
				}
			},
			// 重置滑块
			resetCaptcha() {
				this.sessionToken = null
				this.registerToken = null
				if (this.$refs.captchaDialog) {
					this.$refs.captchaDialog.refresh()
				}
			},
			// 滑块验证成功回调（收到 sessionToken）
			async onCaptchaVerified({
				sessionToken
			}) {
				this.sessionToken = sessionToken
				// 自动绑定注册令牌
				if (!await this.bindRegisterToken()) {
					return;
				}
				this.randomCode = Math.floor(Math.random() * 10000).toString();
				let self = this;
				let requsetData = {
					data: {
						SmsSdkAppId: "1400977981", // 短信应用ID
						SignName: "北京果熊科技", // 审核通过的签名
						TemplateId: this.codeType == 'register' ? "2406465" : "2406468", // 模板ID
						PhoneNumberSet: [this.telephone], // E.164格式号码‌:ml-citation{ref="7" data="citationList"}
						TemplateParamSet: [self.randomCode.toString()] // 模板变量（如验证码）
					},
					registerToken: this.registerToken,
					deviceId: this.deviceId
				}
				this.$axios.post('/api/Util/SendTencentSMS', requsetData).then(function(result) {
					if (result.data.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: result.data.errorMsg
						});
						return;
					}
					self.$Notice.success({
						title: '成功提示',
						duration: 3,
						desc: "短信发送可能有些延迟，请耐心等待"
					});
					setTimeout(function() {
						self.randomCode = '';
					}, 900000)
					self.startCountdown();
				}).catch(err => {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "发送验证码失败"
					});
				})
			},
			// 重置滑块（当登录失败时）
			resetCaptcha() {
				this.sessionToken = null
				this.userToken = null
				if (this.$refs.captcha) {
					this.$refs.captcha.refresh()
				}
			}, // 显示验证码弹窗
			async showCaptcha() {
				try {
					const sessionToken = await this.$refs.captchaDialog.open()
				} catch (err) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "验证已取消"
					});
				}
			},

			// 弹窗关闭回调（用户主动关闭）
			onDialogClose() {},
			startCountdown() {
				this.countdownState = true;
				this.countdownValue = this.timeRemaining + '秒后重发';
				let countdownInterval = setInterval(() => {
					this.timeRemaining--;
					this.countdownValue = this.timeRemaining + '秒后重发';
					if (this.timeRemaining <= 0) {
						clearInterval(countdownInterval);
						this.countdownState = false;
						this.timeRemaining = 60;
						this.countdownValue = '获取验证码';
					}
					// 使用Vue的响应式特性自动更新视图
				}, 1000);
			},
			countdown() {
				if (this.telephone.length != 11 || isNaN(this.telephone)) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '手机号不正确'
					});
					return false;
				}

				//打开验证码
				this.showCaptcha();
			},
			inputChange(val) {
				this.$emit('result', {
					value: this.checkCode,
					randomCode: this.randomCode,
					deviceId:this.deviceId,
					registerToken:this.registerToken
				});
			}
		}
	}
</script>

<style>
	.check-code-input {
		width: 57%;
		display: inline-block;
		margin-right: 10px;
	}

	.check-code-button {
		width: 43;
		display: inline-block;
	}
</style>